import gql from 'graphql-tag';
export default gql`
  query getOrgProfilesByDomain($domain: String!) {
    getOrgProfilesByDomain(domain: $domain)
  }
`;
